<div class="dashboard-header1 border border-1  border-danger d-md-block d-none">
  <div class="header-content">
    <h1 class="logo">SmartSeller <span>{{headersHeading}}</span></h1>
    <div class="user-info">
      <span class="user-name">{{customer.firstName}} {{customer.lastName}}</span>
      <div class="user-avatar">{{userCode}}</div>
    </div>
  </div>
</div>
